<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script setup>
import { ref, computed } from 'vue';
const props = defineProps({
  iconClass: {
    type: String,
    required: true,
  },
  ClassName: {
    type: String,
    default: '',
  },
});

const iconName = computed(() => '#icon-' + props.iconClass);
const svgClass = computed(() => 'svg-icon ' + (props.ClassName || ''));
</script>
<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
